import { withLayouts } from 'react-dx'
import { useLingui } from '@lingui/react/macro'

import DefaultLayout from '../_layout'
import RootLayout from '../_layout/layouts/RootLayout'
import SiteSpecificContextLayout from '../_layout/layouts/SiteSpecificContextLayout'
import AntdLayout from '../_layout/layouts/AntdLayout'
import ExperimentPlansEntry from '../_blocks/Plans/ExperimentPlansEntry'

import { PricePageProvider } from './context'
import Banner from './_blocks/Banner'

import type { InferGetServerSidePropsType, NextPage } from 'next'

import { getServerSideData } from '@/helpers/server-data'
import { ProductsSubAppName } from '@/contexts/SiteSpecificContext/types'


import { cls } from 'tagged-classnames-free';
const Page: NextPage<InferGetServerSidePropsType<typeof getServerSideProps>> = (
  props,
) => {
  const { productsList } = props
  return (
    <PricePageProvider>
      <div className={`relative size-full`}>
        <div className={cls`absolute left-0 top-0 size-full blur-xl`}></div>
        <Banner className={cls`relative`}>
          <ExperimentPlansEntry
            isModal={false}
            appName={ProductsSubAppName.App1}
            productList={productsList}
          />
        </Banner>
      </div>
    </PricePageProvider>
  )
}

const LayoutsPage = withLayouts(Page, [
  (props) => {
    return (
      <DefaultLayout
        {...props}
        minHScreen
        main={{
          className: 'bg-f-bg-base !pl-0',
        }}
        sideBar={{
          className: '',
        }}
      />
    )
  },
  (props) => {
    const { t } = useLingui()
    return (
      <RootLayout
        {...props}
        seo={{
          title: t`Plans & Pricing | Tad AI`,
          description: t`Discover Tad.ai's flexible and budget-friendly pricing options for AI-generated music creation. Explore our range of plans designed to cater to your unique needs, from personal projects to professional use.`,
        }}
      />
    )
  },
  (props) => {
    return <SiteSpecificContextLayout {...props} />
  },
  AntdLayout,
])

// eslint-disable-next-line react-refresh/only-export-components
export const getServerSideProps = getServerSideData({ cacheControl: true })(
  async (_, ctx, helpers) => {
    const apiCaller = await helpers.getApiCaller()
    const { productsList } = await apiCaller.product.getProductsList({
      appName: ProductsSubAppName.App1,
    })
    return {
      productsList,
    }
  },
)

export default LayoutsPage
